import {
  ADD_PAYMENT_METHODS,
  ADD_SUPPLEMENTAL_FILES,
  GET_ACCOUNT_KYB_STATUS,
  GET_APPROVED_PAYMENT_METHODS_FOR_ONGOING_KYB,
  GET_CLIENT_LEGAL_ENTITY,
  GET_DRAFT,
  GET_FILE_UPLOAD_TOKEN,
  GET_I18N_CONTENT,
  GET_IN_PROGRESS_PAYMENT_METHODS_FOR_INCREMENTAL_PAYMENT_ACTIVATION,
  GET_IN_PROGRESS_PAYMENT_METHODS_FOR_INITIAL_PAYMENT_ACTIVATION,
  GET_IN_PROGRESS_PAYMENT_METHODS_FOR_SELECT_RESERVE,
  GET_IN_REVIEW_PAYMENT_METHODS,
  GET_MERCHANT_DATA,
  GET_MID_RATE,
  GET_NEW_PAYMENT_METHOD_REQUIRED_INFO,
  GET_ONGOING_CASE,
  GET_PAYMENT_METHODS,
  GET_PLATFORM_PAYMENT_METHODS,
  GET_PLATFORM_PAYMENTS_TYPE,
  GET_RESERVE_OPTIONS,
  GET_RESERVE_OPTIONS_FOR_ONGOING_KYB,
  GET_SCALE_SETTING_BY_PLATFORM_ACCOUNT_ID,
  GET_USER_PAYMENT_METHODS_STATUS,
  GET_USER_RESERVE_PLAN,
  GET_USER_SELECTED_PAYMENT_METHODS,
  SAVE_DRAFT,
  SELECT_RESERVE,
  SUBMIT_KYB,
} from './gql';

// DocumentNode is a plain GraphQL query string (no Apollo dependency)
// eslint-disable-next-line @typescript-eslint/no-unused-vars
type DocumentNode<_TData = any, _TVariables = any> = string;
export type Maybe<T> = T;
export type InputMaybe<T> = T | null | undefined;
export type Exact<T extends { [key: string]: unknown }> = {
  [K in keyof T]: T[K];
};
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]?: Maybe<T[SubKey]>;
};
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & {
  [SubKey in K]: Maybe<T[SubKey]>;
};
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  JSON: any;
  PermissionContext: any;
};

export enum AccountKybStatus {
  Accepted = 'ACCEPTED',
  Approved = 'APPROVED',
  InReview = 'IN_REVIEW',
  InReviewWithSupplement = 'IN_REVIEW_WITH_SUPPLEMENT',
  NoStatus = 'NO_STATUS',
  Processing = 'PROCESSING',
  Rejected = 'REJECTED',
  RejectedManual = 'REJECTED_MANUAL',
}

export type ActivatedPaymentMethodInput = {
  name?: InputMaybe<Scalars['String']>;
  shopperCountry?: InputMaybe<Scalars['String']>;
};

export type AddPaymentMethodsRequest = {
  fulfillmentDays?: InputMaybe<Scalars['Int']>;
  newPaymentMethods: Array<NewPaymentMethod>;
  newWebsiteUrls: Array<Scalars['String']>;
  paymentTypeDistribution: Array<PaymentTypeDistribution>;
};

export type AddPaymentMethodsResponse = {
  __typename?: 'AddPaymentMethodsResponse';
  message?: Maybe<Scalars['String']>;
  ongoingCaseId?: Maybe<Scalars['String']>;
  ongoingCaseStatus?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
};

export type AdditionalInfo = {
  __typename?: 'AdditionalInfo';
  proposedReserveOffer?: Maybe<ProposedReserveOffer>;
};

export type Address = {
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  line?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<Scalars['String']>;
  zipcode?: InputMaybe<Scalars['String']>;
};

export type AttachmentToken = {
  __typename?: 'AttachmentToken';
  endpoint: Scalars['String'];
  form_data: Scalars['JSON'];
  id: Scalars['String'];
};

export type BaseResponse = {
  __typename?: 'BaseResponse';
  status?: Maybe<Scalars['String']>;
};

export type BusinessDetails = {
  __typename?: 'BusinessDetails';
  address?: Maybe<BusinessDetailsAddress>;
  descriptionOfGoodsOrServices?: Maybe<Scalars['String']>;
  industryCategory?: Maybe<IndustryCategory>;
  tradingName?: Maybe<Scalars['String']>;
};

export type BusinessDetailsAddress = {
  __typename?: 'BusinessDetailsAddress';
  countryCode?: Maybe<Scalars['String']>;
  postcode?: Maybe<Scalars['String']>;
  state?: Maybe<NameWithEnglish>;
  streetAddresses?: Maybe<Array<Maybe<NameWithEnglish>>>;
  suburb?: Maybe<NameWithEnglish>;
};

export type BusinessProfile = {
  __typename?: 'BusinessProfile';
  businessDetails?: Maybe<BusinessDetails>;
};

export enum BusinessType {
  BusinessWithoutStore = 'BUSINESS_WITHOUT_STORE',
  OnlineStore = 'ONLINE_STORE',
  PhysicalStore = 'PHYSICAL_STORE',
}

export enum ClientType {
  Embedded = 'EMBEDDED',
  Salesforce = 'SALESFORCE',
  Webapp = 'WEBAPP',
}

export type ContentImage = {
  __typename?: 'ContentImage';
  mimeType: Scalars['String'];
  title: Scalars['String'];
  url: Scalars['String'];
};

export type CurrencyAmount = {
  __typename?: 'CurrencyAmount';
  amount: Scalars['String'];
  currency: Scalars['String'];
};

export type CustomizedReserve = {
  __typename?: 'CustomizedReserve';
  delayedDays?: Maybe<Scalars['Int']>;
  rollingDays?: Maybe<Scalars['Int']>;
  rollingRate?: Maybe<Scalars['String']>;
};

export type DefaultConnectionPermission = {
  __typename?: 'DefaultConnectionPermission';
  defaultPermissionToConnectedAccount?: Maybe<DefaultPermissionToConnectedAccount>;
};

export type DefaultPermissionToConnectedAccount = {
  __typename?: 'DefaultPermissionToConnectedAccount';
  permissionContext?: Maybe<Scalars['PermissionContext']>;
  permissions?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export enum DraftType {
  AddPaymentMethod = 'ADD_PAYMENT_METHOD',
  Onboard = 'ONBOARD',
}

export type EvaluateRequestInput = {
  accountId?: InputMaybe<Scalars['String']>;
  clientType?: InputMaybe<ClientType>;
  legalEntityId?: InputMaybe<Scalars['String']>;
  storeList?: InputMaybe<Array<InputMaybe<Store>>>;
  userId?: InputMaybe<Scalars['String']>;
};

export type ExistingPaymentMethod = {
  __typename?: 'ExistingPaymentMethod';
  paymentMethodName: Scalars['String'];
  paymentMethodProvider?: Maybe<Scalars['String']>;
  shopperCountry?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export type GetAccountKybStatusResponse = {
  __typename?: 'GetAccountKYBStatusResponse';
  caseId?: Maybe<Scalars['String']>;
  status: AccountKybStatus;
};

export type GetClientLegalEntity = {
  __typename?: 'GetClientLegalEntity';
  id?: Maybe<Scalars['String']>;
  profile?: Maybe<BusinessProfile>;
};

export type GetFileUploadTokenInput = {
  mime_types?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type GetInReviewPaymentMethodsResponse = {
  __typename?: 'GetInReviewPaymentMethodsResponse';
  paymentMethodName: Scalars['String'];
  paymentMethodProvider?: Maybe<Scalars['String']>;
  shopperCountry?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export type GetMerchantDataResponse = {
  __typename?: 'GetMerchantDataResponse';
  profile?: Maybe<MerchantProfile>;
};

export type GetMidRateResponse = {
  __typename?: 'GetMidRateResponse';
  buyCcy?: Maybe<Scalars['String']>;
  rate?: Maybe<Scalars['Float']>;
  rateType?: Maybe<Scalars['String']>;
  sellCcy?: Maybe<Scalars['String']>;
};

export type GetNewPaymentMethodRequiredInfoResponse = {
  __typename?: 'GetNewPaymentMethodRequiredInfoResponse';
  fulfillmentDaysRequired?: Maybe<Scalars['Boolean']>;
  paymentTypeDistributionRequired?: Maybe<Scalars['Boolean']>;
  websiteRequired?: Maybe<Scalars['Boolean']>;
};

export type GetOngoingCaseResponse = {
  __typename?: 'GetOngoingCaseResponse';
  accountId?: Maybe<Scalars['String']>;
  additionalInfo?: Maybe<AdditionalInfo>;
  caseType?: Maybe<Scalars['String']>;
  createAt?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['String']>;
  legalEntityId?: Maybe<Scalars['String']>;
  owningEntity?: Maybe<Scalars['String']>;
  requests?: Maybe<Array<Maybe<Request>>>;
  status?: Maybe<Scalars['String']>;
};

export type GetPlatformPaymentMethodsResponse = {
  __typename?: 'GetPlatformPaymentMethodsResponse';
  allowedSelection: Scalars['Boolean'];
  paymentMethods: Array<PaymentMethod>;
};

export type GetPlatformPaymentsTypeResponse = {
  __typename?: 'GetPlatformPaymentsTypeResponse';
  platformPaymentsType?: Maybe<Scalars['String']>;
};

export type GetReserveOptionsResponse = {
  __typename?: 'GetReserveOptionsResponse';
  currentReserveOffer?: Maybe<ReserveOption>;
  currentReserveOfferSourceCaseId?: Maybe<Scalars['String']>;
  paymentMethodsNeedReserve?: Maybe<Array<Scalars['String']>>;
  previousChoice?: Maybe<Scalars['String']>;
  previousReserveOffer?: Maybe<ReserveOption>;
  previousReserveOfferSourceCaseId?: Maybe<Scalars['String']>;
};

export type GetScaleSettingByPlatformAccountIdResponse = {
  __typename?: 'GetScaleSettingByPlatformAccountIdResponse';
  scaleConnectionSetting?: Maybe<ScaleConnectionSetting>;
};

export type GetUserPaymentMethodsStatus = {
  __typename?: 'GetUserPaymentMethodsStatus';
  pmList?: Maybe<Array<PaymentMethodWithStatus>>;
};

export type GetUserReservePlan = {
  __typename?: 'GetUserReservePlan';
  autoAccepted?: Maybe<Scalars['Boolean']>;
  currency?: Maybe<Scalars['String']>;
  currentReserveOffer?: Maybe<ReserveOption>;
  currentReserveOfferSourceCaseId?: Maybe<Scalars['String']>;
  delayedDays?: Maybe<Scalars['Float']>;
  fixedAmount?: Maybe<Scalars['Float']>;
  kybOnboarded?: Maybe<Scalars['Boolean']>;
  mandatoryDelayedDays?: Maybe<Scalars['Float']>;
  previousChoice?: Maybe<UserReserveSelection>;
  previousReserveOffer?: Maybe<ReserveOption>;
  previousReserveOfferSourceCaseId?: Maybe<Scalars['String']>;
  rollingDays?: Maybe<Scalars['Float']>;
  rollingRate?: Maybe<Scalars['Float']>;
};

export type I18nContent = {
  __typename?: 'I18nContent';
  i18nContentImage?: Maybe<Array<Maybe<I18nContentImage>>>;
  i18nContentLabel?: Maybe<Array<Maybe<I18nContentLabel>>>;
};

export type I18nContentImage = {
  __typename?: 'I18nContentImage';
  image: ContentImage;
  key: Scalars['String'];
};

export type I18nContentLabel = {
  __typename?: 'I18nContentLabel';
  key: Scalars['String'];
  label: Scalars['String'];
};

export type IndustryCategory = {
  __typename?: 'IndustryCategory';
  categoryCode?: Maybe<Scalars['String']>;
};

export enum IndustryOutcome {
  Accepted = 'ACCEPTED',
  InReview = 'IN_REVIEW',
  Rejected = 'REJECTED',
}

export enum MccSource {
  BdIndustry = 'BD_INDUSTRY',
  KybIndustry = 'KYB_INDUSTRY',
  UserIndustry = 'USER_INDUSTRY',
}

export type MerchantProfile = {
  __typename?: 'MerchantProfile';
  accountId?: Maybe<Scalars['String']>;
  legalEntityId?: Maybe<Scalars['String']>;
  paymentMethods: Array<ExistingPaymentMethod>;
  paymentTypeDistribution: Array<PaymentTypeDistributionOutput>;
};

export type Mutation = {
  __typename?: 'Mutation';
  addPaymentMethods: AddPaymentMethodsResponse;
  addSupplementalFiles: BaseResponse;
  saveDraft: BaseResponse;
  selectReserve: BaseResponse;
  submitKyb: BaseResponse;
};

export type MutationAddPaymentMethodsArgs = {
  addPaymentMethodsRequest: AddPaymentMethodsRequest;
};

export type MutationAddSupplementalFilesArgs = {
  fileUris: Array<Scalars['String']>;
};

export type MutationSaveDraftArgs = {
  draft: Scalars['String'];
  draftType?: InputMaybe<DraftType>;
};

export type MutationSelectReserveArgs = {
  caseId: Scalars['String'];
  userSelection: UserReserveSelection;
};

export type MutationSubmitKybArgs = {
  evaluateRequest: EvaluateRequestInput;
};

export type NameWithEnglish = {
  __typename?: 'NameWithEnglish';
  english?: Maybe<Scalars['String']>;
  local?: Maybe<Scalars['String']>;
};

export type NewPaymentMethod = {
  paymentMethodName: Scalars['String'];
  paymentMethodProvider: Scalars['String'];
  shopperCountry: Scalars['String'];
  type: Scalars['String'];
};

export type NewPaymentMethodOutput = {
  __typename?: 'NewPaymentMethodOutput';
  paymentMethodName?: Maybe<Scalars['String']>;
  paymentMethodProvider?: Maybe<Scalars['String']>;
  shopperCountry?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export type PaymentMethod = {
  __typename?: 'PaymentMethod';
  activationTimeMax: Scalars['Int'];
  activationTimeMin: Scalars['Int'];
  code: Scalars['String'];
  description: Scalars['String'];
  isPopular: Scalars['Boolean'];
  locations: Array<Scalars['String']>;
  name: Scalars['String'];
  productTypes: Array<Scalars['String']>;
  requireReserve: Scalars['Boolean'];
  requiresOnlineWebsiteUrl: Scalars['Boolean'];
  type: Scalars['String'];
};

export enum PaymentMethodStatus {
  Activated = 'ACTIVATED',
  InfoRequired = 'INFO_REQUIRED',
  InProgress = 'IN_PROGRESS',
  Rejected = 'REJECTED',
}

export type PaymentMethodWithStatus = {
  __typename?: 'PaymentMethodWithStatus';
  code: Scalars['String'];
  name: Scalars['String'];
  requireReserve: Scalars['Boolean'];
  status: PaymentMethodStatus;
};

export type PaymentMethodsWithVolume = {
  name?: InputMaybe<Scalars['String']>;
  shopperCountry?: InputMaybe<Scalars['String']>;
};

export type PaymentTypeDistribution = {
  paymentType: Scalars['String'];
  ratio: Scalars['String'];
};

export type PaymentTypeDistributionOutput = {
  __typename?: 'PaymentTypeDistributionOutput';
  paymentType?: Maybe<Scalars['String']>;
  ratio?: Maybe<Scalars['String']>;
};

export type PaymentTypeRatioInput = {
  paymentType?: InputMaybe<Scalars['String']>;
  ratio?: InputMaybe<Scalars['String']>;
};

export type PlatformAccountSetting = {
  __typename?: 'PlatformAccountSetting';
  allowSkipBusinessRegistrationDocVerification?: Maybe<Scalars['Boolean']>;
  awxAsksForPermissionApproval?: Maybe<Scalars['Boolean']>;
  billingModel?: Maybe<Scalars['String']>;
  canConnectExistingAccount?: Maybe<Scalars['Boolean']>;
  canDownloadConnectedAccountsOnboardingDocs?: Maybe<Scalars['Boolean']>;
  canUpdateClientType?: Maybe<Scalars['Boolean']>;
  clientType?: Maybe<Scalars['String']>;
  componentTheme?: Maybe<Scalars['String']>;
  enabled?: Maybe<Scalars['Boolean']>;
  merchantBusinessTypes?: Maybe<Array<Maybe<Scalars['String']>>>;
  platformCustomEmailSenderAddress?: Maybe<Scalars['String']>;
  platformEmailForConnectedAccountRFI?: Maybe<Scalars['String']>;
  sendConnectedAccountRFIToPlatform?: Maybe<Scalars['Boolean']>;
  useCustomEmailSenderAddress?: Maybe<Scalars['Boolean']>;
};

export type ProposedReserveOffer = {
  __typename?: 'ProposedReserveOffer';
  coverage?: Maybe<Scalars['String']>;
  currency?: Maybe<Scalars['String']>;
  customizedReserve?: Maybe<CustomizedReserve>;
  delayedDays?: Maybe<Scalars['Int']>;
  disabledOptions?: Maybe<Array<Maybe<Scalars['String']>>>;
  exposure?: Maybe<Scalars['String']>;
  fixedAmount?: Maybe<Scalars['String']>;
  mandatoryDelayedDays?: Maybe<Scalars['Int']>;
  rollingDays?: Maybe<Scalars['Int']>;
  rollingDays2?: Maybe<Scalars['Int']>;
  rollingRate?: Maybe<Scalars['String']>;
  rollingRate2?: Maybe<Scalars['String']>;
};

export type Query = {
  __typename?: 'Query';
  getAccountKYBStatus?: Maybe<GetAccountKybStatusResponse>;
  getApprovedPaymentMethodsForOngoingKyb: Array<ExistingPaymentMethod>;
  getClientLegalEntity?: Maybe<GetClientLegalEntity>;
  getDraft?: Maybe<Scalars['String']>;
  getFileUploadToken: Array<AttachmentToken>;
  getI18nContent?: Maybe<I18nContent>;
  getInProgressPaymentMethodsForIncrementalPaymentActivation: Array<PaymentMethodWithStatus>;
  getInProgressPaymentMethodsForInitialPaymentActivation: Array<PaymentMethodWithStatus>;
  getInProgressPaymentMethodsForSelectReserve: Array<PaymentMethodWithStatus>;
  getInReviewPaymentMethods?: Maybe<
    Array<Maybe<GetInReviewPaymentMethodsResponse>>
  >;
  getMerchantData?: Maybe<Array<Maybe<GetMerchantDataResponse>>>;
  getMidRate?: Maybe<GetMidRateResponse>;
  getNewPaymentMethodRequiredInfo: GetNewPaymentMethodRequiredInfoResponse;
  getOngoingCase?: Maybe<GetOngoingCaseResponse>;
  getPaymentMethods: Array<PaymentMethod>;
  getPlatformPaymentMethods?: Maybe<GetPlatformPaymentMethodsResponse>;
  getPlatformPaymentsType?: Maybe<GetPlatformPaymentsTypeResponse>;
  getReserveOptions?: Maybe<GetReserveOptionsResponse>;
  getReserveOptionsForOngoingKyb?: Maybe<GetReserveOptionsResponse>;
  getScaleSettingByPlatformAccountId: GetScaleSettingByPlatformAccountIdResponse;
  getUserPaymentMethodsStatus?: Maybe<GetUserPaymentMethodsStatus>;
  getUserReservePlan?: Maybe<GetUserReservePlan>;
  /** @deprecated getUserSelectedPaymentMethods is deprecated. Use makeUpStatusForInitialPaymentActivation instead. */
  getUserSelectedPaymentMethods: Array<PaymentMethodWithStatus>;
};

export type QueryGetDraftArgs = {
  draftType?: InputMaybe<DraftType>;
};

export type QueryGetFileUploadTokenArgs = {
  mime_types?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type QueryGetI18nContentArgs = {
  langKey: Scalars['String'];
};

export type QueryGetInProgressPaymentMethodsForIncrementalPaymentActivationArgs =
  {
    caseId?: InputMaybe<Scalars['String']>;
    langKey: Scalars['String'];
  };

export type QueryGetInProgressPaymentMethodsForInitialPaymentActivationArgs = {
  langKey: Scalars['String'];
};

export type QueryGetInProgressPaymentMethodsForSelectReserveArgs = {
  activatedPaymentMethods?: InputMaybe<
    Array<InputMaybe<ActivatedPaymentMethodInput>>
  >;
  langKey: Scalars['String'];
};

export type QueryGetMidRateArgs = {
  buyCcy: Scalars['String'];
};

export type QueryGetNewPaymentMethodRequiredInfoArgs = {
  paymentMethods?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

export type QueryGetOngoingCaseArgs = {
  caseId?: InputMaybe<Scalars['String']>;
};

export type QueryGetPaymentMethodsArgs = {
  langKey: Scalars['String'];
};

export type QueryGetPlatformPaymentMethodsArgs = {
  langKey: Scalars['String'];
  platformAccountId: Scalars['String'];
};

export type QueryGetPlatformPaymentsTypeArgs = {
  platformAccountId: Scalars['String'];
};

export type QueryGetReserveOptionsArgs = {
  langKey: Scalars['String'];
};

export type QueryGetReserveOptionsForOngoingKybArgs = {
  caseId?: InputMaybe<Scalars['String']>;
  langKey: Scalars['String'];
};

export type QueryGetScaleSettingByPlatformAccountIdArgs = {
  platformAccountId: Scalars['String'];
};

export type QueryGetUserPaymentMethodsStatusArgs = {
  langKey: Scalars['String'];
};

export type QueryGetUserSelectedPaymentMethodsArgs = {
  langKey: Scalars['String'];
};

export type Request = {
  __typename?: 'Request';
  accountId?: Maybe<Scalars['String']>;
  newPaymentMethods?: Maybe<Array<Maybe<NewPaymentMethodOutput>>>;
};

export type ReserveOption = {
  __typename?: 'ReserveOption';
  currency?: Maybe<Scalars['String']>;
  customizedReserve?: Maybe<CustomizedReserve>;
  delayedDays?: Maybe<Scalars['Int']>;
  disabledOptions: Array<Scalars['String']>;
  fixedAmount?: Maybe<Scalars['String']>;
  mandatoryDelayedDays?: Maybe<Scalars['Int']>;
  rollingDays?: Maybe<Scalars['Int']>;
  rollingDays2?: Maybe<Scalars['Int']>;
  rollingRate?: Maybe<Scalars['String']>;
  rollingRate2?: Maybe<Scalars['String']>;
};

export type ScaleConnectionSetting = {
  __typename?: 'ScaleConnectionSetting';
  defaultConnectionPermission?: Maybe<DefaultConnectionPermission>;
  id?: Maybe<Scalars['String']>;
  platformAccountSetting?: Maybe<PlatformAccountSetting>;
};

export type Store = {
  accountId?: InputMaybe<Scalars['String']>;
  address?: InputMaybe<Address>;
  averageTransactionAmount?: InputMaybe<Scalars['String']>;
  businessType?: InputMaybe<Array<InputMaybe<BusinessType>>>;
  cbtPercentage?: InputMaybe<Scalars['String']>;
  chargebackRate?: InputMaybe<Scalars['String']>;
  currency?: InputMaybe<Scalars['String']>;
  fulfillmentDays?: InputMaybe<Scalars['Int']>;
  getPaidEnablement?: InputMaybe<Scalars['Boolean']>;
  industryCode?: InputMaybe<Scalars['String']>;
  legalEntityId?: InputMaybe<Scalars['String']>;
  maxTransactionAmount?: InputMaybe<Scalars['String']>;
  mcc?: InputMaybe<Scalars['String']>;
  mccSource?: InputMaybe<MccSource>;
  monthlyTransactionAmount?: InputMaybe<Scalars['String']>;
  paymentMethodsWithVolume?: InputMaybe<
    Array<InputMaybe<PaymentMethodsWithVolume>>
  >;
  paymentTypeDistribution?: InputMaybe<
    Array<InputMaybe<PaymentTypeRatioInput>>
  >;
  products?: InputMaybe<Array<InputMaybe<StoreProduct>>>;
  refundRate?: InputMaybe<Scalars['String']>;
  storeDescription?: InputMaybe<Scalars['String']>;
  storeName?: InputMaybe<Scalars['String']>;
  storeUrl?: InputMaybe<Scalars['String']>;
  wechatCategory?: InputMaybe<Scalars['String']>;
};

export enum StoreProduct {
  Invoices = 'INVOICES',
  OnlinePayments = 'ONLINE_PAYMENTS',
  PaymentLinks = 'PAYMENT_LINKS',
}

export enum UserReserveSelection {
  Delay = 'DELAY',
  FixedAmount = 'FIXED_AMOUNT',
  Mixed = 'MIXED',
  NotAccepted = 'NOT_ACCEPTED',
  Rolling = 'ROLLING',
  Rolling_2 = 'ROLLING_2',
}

export type GetAccountKybStatusQueryVariables = Exact<{ [key: string]: never }>;

export type GetAccountKybStatusQuery = {
  __typename?: 'Query';
  getAccountKYBStatus?: {
    __typename?: 'GetAccountKYBStatusResponse';
    caseId?: string;
    status: AccountKybStatus;
  };
};

export type GetApprovedPaymentMethodsForOngoingKybQueryVariables = Exact<{
  [key: string]: never;
}>;

export type GetApprovedPaymentMethodsForOngoingKybQuery = {
  __typename?: 'Query';
  getApprovedPaymentMethodsForOngoingKyb: Array<{
    __typename?: 'ExistingPaymentMethod';
    paymentMethodName: string;
    paymentMethodProvider?: string;
    shopperCountry?: string;
    type?: string;
  }>;
};

export type GetClientLegalEntityQueryVariables = Exact<{
  [key: string]: never;
}>;

export type GetClientLegalEntityQuery = {
  __typename?: 'Query';
  getClientLegalEntity?: {
    __typename?: 'GetClientLegalEntity';
    id?: string;
    profile?: {
      __typename?: 'BusinessProfile';
      businessDetails?: {
        __typename?: 'BusinessDetails';
        descriptionOfGoodsOrServices?: string;
        tradingName?: string;
        address?: {
          __typename?: 'BusinessDetailsAddress';
          countryCode?: string;
          postcode?: string;
          state?: {
            __typename?: 'NameWithEnglish';
            english?: string;
            local?: string;
          };
          streetAddresses?: Array<{
            __typename?: 'NameWithEnglish';
            english?: string;
            local?: string;
          }>;
          suburb?: {
            __typename?: 'NameWithEnglish';
            english?: string;
            local?: string;
          };
        };
        industryCategory?: {
          __typename?: 'IndustryCategory';
          categoryCode?: string;
        };
      };
    };
  };
};

export type GetDraftQueryVariables = Exact<{
  draftType?: InputMaybe<DraftType>;
}>;

export type GetDraftQuery = { __typename?: 'Query'; getDraft?: string };

export type GetFileUploadTokenQueryVariables = Exact<{
  mime_types?: InputMaybe<
    Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>
  >;
}>;

export type GetFileUploadTokenQuery = {
  __typename?: 'Query';
  getFileUploadToken: Array<{
    __typename?: 'AttachmentToken';
    endpoint: string;
    form_data: any;
    id: string;
  }>;
};

export type GetI18nContentQueryVariables = Exact<{
  langKey: Scalars['String'];
}>;

export type GetI18nContentQuery = {
  __typename?: 'Query';
  getI18nContent?: {
    __typename?: 'I18nContent';
    i18nContentImage?: Array<{
      __typename?: 'I18nContentImage';
      key: string;
      image: {
        __typename?: 'ContentImage';
        mimeType: string;
        title: string;
        url: string;
      };
    }>;
    i18nContentLabel?: Array<{
      __typename?: 'I18nContentLabel';
      key: string;
      label: string;
    }>;
  };
};

export type GetInProgressPaymentMethodsForIncrementalPaymentActivationQueryVariables =
  Exact<{
    caseId?: InputMaybe<Scalars['String']>;
    langKey: Scalars['String'];
  }>;

export type GetInProgressPaymentMethodsForIncrementalPaymentActivationQuery = {
  __typename?: 'Query';
  getInProgressPaymentMethodsForIncrementalPaymentActivation: Array<{
    __typename?: 'PaymentMethodWithStatus';
    code: string;
    name: string;
    requireReserve: boolean;
    status: PaymentMethodStatus;
  }>;
};

export type GetInProgressPaymentMethodsForInitialPaymentActivationQueryVariables =
  Exact<{
    langKey: Scalars['String'];
  }>;

export type GetInProgressPaymentMethodsForInitialPaymentActivationQuery = {
  __typename?: 'Query';
  getInProgressPaymentMethodsForInitialPaymentActivation: Array<{
    __typename?: 'PaymentMethodWithStatus';
    code: string;
    name: string;
    requireReserve: boolean;
    status: PaymentMethodStatus;
  }>;
};

export type GetInProgressPaymentMethodsForSelectReserveQueryVariables = Exact<{
  activatedPaymentMethods?: InputMaybe<
    | Array<InputMaybe<ActivatedPaymentMethodInput>>
    | InputMaybe<ActivatedPaymentMethodInput>
  >;
  langKey: Scalars['String'];
}>;

export type GetInProgressPaymentMethodsForSelectReserveQuery = {
  __typename?: 'Query';
  getInProgressPaymentMethodsForSelectReserve: Array<{
    __typename?: 'PaymentMethodWithStatus';
    code: string;
    name: string;
    requireReserve: boolean;
    status: PaymentMethodStatus;
  }>;
};

export type GetInReviewPaymentMethodsQueryVariables = Exact<{
  [key: string]: never;
}>;

export type GetInReviewPaymentMethodsQuery = {
  __typename?: 'Query';
  getInReviewPaymentMethods?: Array<{
    __typename?: 'GetInReviewPaymentMethodsResponse';
    paymentMethodName: string;
    paymentMethodProvider?: string;
    shopperCountry?: string;
    type?: string;
  }>;
};

export type GetMerchantDataQueryVariables = Exact<{ [key: string]: never }>;

export type GetMerchantDataQuery = {
  __typename?: 'Query';
  getMerchantData?: Array<{
    __typename?: 'GetMerchantDataResponse';
    profile?: {
      __typename?: 'MerchantProfile';
      accountId?: string;
      legalEntityId?: string;
      paymentMethods: Array<{
        __typename?: 'ExistingPaymentMethod';
        paymentMethodName: string;
        paymentMethodProvider?: string;
        shopperCountry?: string;
        type?: string;
      }>;
      paymentTypeDistribution: Array<{
        __typename?: 'PaymentTypeDistributionOutput';
        paymentType?: string;
        ratio?: string;
      }>;
    };
  }>;
};

export type GetMidRateQueryVariables = Exact<{
  buyCcy: Scalars['String'];
}>;

export type GetMidRateQuery = {
  __typename?: 'Query';
  getMidRate?: {
    __typename?: 'GetMidRateResponse';
    buyCcy?: string;
    rate?: number;
    rateType?: string;
    sellCcy?: string;
  };
};

export type GetNewPaymentMethodRequiredInfoQueryVariables = Exact<{
  paymentMethods?: InputMaybe<
    Array<InputMaybe<Scalars['String']>> | InputMaybe<Scalars['String']>
  >;
}>;

export type GetNewPaymentMethodRequiredInfoQuery = {
  __typename?: 'Query';
  getNewPaymentMethodRequiredInfo: {
    __typename?: 'GetNewPaymentMethodRequiredInfoResponse';
    fulfillmentDaysRequired?: boolean;
    paymentTypeDistributionRequired?: boolean;
    websiteRequired?: boolean;
  };
};

export type GetOngoingCaseQueryVariables = Exact<{
  caseId?: InputMaybe<Scalars['String']>;
}>;

export type GetOngoingCaseQuery = {
  __typename?: 'Query';
  getOngoingCase?: {
    __typename?: 'GetOngoingCaseResponse';
    accountId?: string;
    caseType?: string;
    createAt?: number;
    id?: string;
    legalEntityId?: string;
    owningEntity?: string;
    status?: string;
    additionalInfo?: {
      __typename?: 'AdditionalInfo';
      proposedReserveOffer?: {
        __typename?: 'ProposedReserveOffer';
        coverage?: string;
        currency?: string;
        delayedDays?: number;
        disabledOptions?: Array<string>;
        exposure?: string;
        fixedAmount?: string;
        mandatoryDelayedDays?: number;
        rollingDays?: number;
        rollingDays2?: number;
        rollingRate?: string;
        rollingRate2?: string;
        customizedReserve?: {
          __typename?: 'CustomizedReserve';
          delayedDays?: number;
          rollingDays?: number;
          rollingRate?: string;
        };
      };
    };
    requests?: Array<{
      __typename?: 'Request';
      accountId?: string;
      newPaymentMethods?: Array<{
        __typename?: 'NewPaymentMethodOutput';
        paymentMethodName?: string;
        paymentMethodProvider?: string;
        shopperCountry?: string;
        type?: string;
      }>;
    }>;
  };
};

export type GetPaymentMethodsQueryVariables = Exact<{
  langKey: Scalars['String'];
}>;

export type GetPaymentMethodsQuery = {
  __typename?: 'Query';
  getPaymentMethods: Array<{
    __typename?: 'PaymentMethod';
    activationTimeMax: number;
    activationTimeMin: number;
    code: string;
    description: string;
    isPopular: boolean;
    locations: Array<string>;
    name: string;
    productTypes: Array<string>;
    requireReserve: boolean;
    requiresOnlineWebsiteUrl: boolean;
    type: string;
  }>;
};

export type GetPlatformPaymentMethodsQueryVariables = Exact<{
  langKey: Scalars['String'];
  platformAccountId: Scalars['String'];
}>;

export type GetPlatformPaymentMethodsQuery = {
  __typename?: 'Query';
  getPlatformPaymentMethods?: {
    __typename?: 'GetPlatformPaymentMethodsResponse';
    allowedSelection: boolean;
    paymentMethods: Array<{
      __typename?: 'PaymentMethod';
      activationTimeMax: number;
      activationTimeMin: number;
      code: string;
      description: string;
      isPopular: boolean;
      locations: Array<string>;
      name: string;
      productTypes: Array<string>;
      requireReserve: boolean;
      requiresOnlineWebsiteUrl: boolean;
      type: string;
    }>;
  };
};

export type GetPlatformPaymentsTypeQueryVariables = Exact<{
  platformAccountId: Scalars['String'];
}>;

export type GetPlatformPaymentsTypeQuery = {
  __typename?: 'Query';
  getPlatformPaymentsType?: {
    __typename?: 'GetPlatformPaymentsTypeResponse';
    platformPaymentsType?: string;
  };
};

export type GetReserveOptionsQueryVariables = Exact<{
  langKey: Scalars['String'];
}>;

export type GetReserveOptionsQuery = {
  __typename?: 'Query';
  getReserveOptions?: {
    __typename?: 'GetReserveOptionsResponse';
    currentReserveOfferSourceCaseId?: string;
    paymentMethodsNeedReserve?: Array<string>;
    previousChoice?: string;
    previousReserveOfferSourceCaseId?: string;
    currentReserveOffer?: {
      __typename?: 'ReserveOption';
      currency?: string;
      delayedDays?: number;
      disabledOptions: Array<string>;
      fixedAmount?: string;
      mandatoryDelayedDays?: number;
      rollingDays?: number;
      rollingDays2?: number;
      rollingRate?: string;
      rollingRate2?: string;
      customizedReserve?: {
        __typename?: 'CustomizedReserve';
        delayedDays?: number;
        rollingDays?: number;
        rollingRate?: string;
      };
    };
    previousReserveOffer?: {
      __typename?: 'ReserveOption';
      currency?: string;
      delayedDays?: number;
      disabledOptions: Array<string>;
      fixedAmount?: string;
      mandatoryDelayedDays?: number;
      rollingDays?: number;
      rollingDays2?: number;
      rollingRate?: string;
      rollingRate2?: string;
      customizedReserve?: {
        __typename?: 'CustomizedReserve';
        delayedDays?: number;
        rollingDays?: number;
        rollingRate?: string;
      };
    };
  };
};

export type GetReserveOptionsForOngoingKybQueryVariables = Exact<{
  caseId?: InputMaybe<Scalars['String']>;
  langKey: Scalars['String'];
}>;

export type GetReserveOptionsForOngoingKybQuery = {
  __typename?: 'Query';
  getReserveOptionsForOngoingKyb?: {
    __typename?: 'GetReserveOptionsResponse';
    currentReserveOfferSourceCaseId?: string;
    paymentMethodsNeedReserve?: Array<string>;
    previousChoice?: string;
    previousReserveOfferSourceCaseId?: string;
    currentReserveOffer?: {
      __typename?: 'ReserveOption';
      currency?: string;
      delayedDays?: number;
      disabledOptions: Array<string>;
      fixedAmount?: string;
      mandatoryDelayedDays?: number;
      rollingDays?: number;
      rollingDays2?: number;
      rollingRate?: string;
      rollingRate2?: string;
      customizedReserve?: {
        __typename?: 'CustomizedReserve';
        delayedDays?: number;
        rollingDays?: number;
        rollingRate?: string;
      };
    };
    previousReserveOffer?: {
      __typename?: 'ReserveOption';
      currency?: string;
      delayedDays?: number;
      disabledOptions: Array<string>;
      fixedAmount?: string;
      mandatoryDelayedDays?: number;
      rollingDays?: number;
      rollingDays2?: number;
      rollingRate?: string;
      rollingRate2?: string;
      customizedReserve?: {
        __typename?: 'CustomizedReserve';
        delayedDays?: number;
        rollingDays?: number;
        rollingRate?: string;
      };
    };
  };
};

export type GetScaleSettingByPlatformAccountIdQueryVariables = Exact<{
  platformAccountId: Scalars['String'];
}>;

export type GetScaleSettingByPlatformAccountIdQuery = {
  __typename?: 'Query';
  getScaleSettingByPlatformAccountId: {
    __typename?: 'GetScaleSettingByPlatformAccountIdResponse';
    scaleConnectionSetting?: {
      __typename?: 'ScaleConnectionSetting';
      id?: string;
      defaultConnectionPermission?: {
        __typename?: 'DefaultConnectionPermission';
        defaultPermissionToConnectedAccount?: {
          __typename?: 'DefaultPermissionToConnectedAccount';
          permissionContext?: any;
          permissions?: Array<string>;
        };
      };
      platformAccountSetting?: {
        __typename?: 'PlatformAccountSetting';
        allowSkipBusinessRegistrationDocVerification?: boolean;
        awxAsksForPermissionApproval?: boolean;
        billingModel?: string;
        canConnectExistingAccount?: boolean;
        canDownloadConnectedAccountsOnboardingDocs?: boolean;
        canUpdateClientType?: boolean;
        clientType?: string;
        componentTheme?: string;
        enabled?: boolean;
        merchantBusinessTypes?: Array<string>;
        platformCustomEmailSenderAddress?: string;
        platformEmailForConnectedAccountRFI?: string;
        sendConnectedAccountRFIToPlatform?: boolean;
        useCustomEmailSenderAddress?: boolean;
      };
    };
  };
};

export type GetUserPaymentMethodsStatusQueryVariables = Exact<{
  langKey: Scalars['String'];
}>;

export type GetUserPaymentMethodsStatusQuery = {
  __typename?: 'Query';
  getUserPaymentMethodsStatus?: {
    __typename?: 'GetUserPaymentMethodsStatus';
    pmList?: Array<{
      __typename?: 'PaymentMethodWithStatus';
      code: string;
      name: string;
      requireReserve: boolean;
      status: PaymentMethodStatus;
    }>;
  };
};

export type GetUserReservePlanQueryVariables = Exact<{ [key: string]: never }>;

export type GetUserReservePlanQuery = {
  __typename?: 'Query';
  getUserReservePlan?: {
    __typename?: 'GetUserReservePlan';
    autoAccepted?: boolean;
    currency?: string;
    currentReserveOfferSourceCaseId?: string;
    delayedDays?: number;
    fixedAmount?: number;
    kybOnboarded?: boolean;
    mandatoryDelayedDays?: number;
    previousChoice?: UserReserveSelection;
    previousReserveOfferSourceCaseId?: string;
    rollingDays?: number;
    rollingRate?: number;
    currentReserveOffer?: {
      __typename?: 'ReserveOption';
      currency?: string;
      delayedDays?: number;
      disabledOptions: Array<string>;
      fixedAmount?: string;
      mandatoryDelayedDays?: number;
      rollingDays?: number;
      rollingDays2?: number;
      rollingRate?: string;
      rollingRate2?: string;
      customizedReserve?: {
        __typename?: 'CustomizedReserve';
        delayedDays?: number;
        rollingDays?: number;
        rollingRate?: string;
      };
    };
    previousReserveOffer?: {
      __typename?: 'ReserveOption';
      currency?: string;
      delayedDays?: number;
      disabledOptions: Array<string>;
      fixedAmount?: string;
      mandatoryDelayedDays?: number;
      rollingDays?: number;
      rollingDays2?: number;
      rollingRate?: string;
      rollingRate2?: string;
      customizedReserve?: {
        __typename?: 'CustomizedReserve';
        delayedDays?: number;
        rollingDays?: number;
        rollingRate?: string;
      };
    };
  };
};

export type GetUserSelectedPaymentMethodsQueryVariables = Exact<{
  langKey: Scalars['String'];
}>;

export type GetUserSelectedPaymentMethodsQuery = {
  __typename?: 'Query';
  getUserSelectedPaymentMethods: Array<{
    __typename?: 'PaymentMethodWithStatus';
    code: string;
    name: string;
    requireReserve: boolean;
    status: PaymentMethodStatus;
  }>;
};

export type AddPaymentMethodsMutationVariables = Exact<{
  addPaymentMethodsRequest: AddPaymentMethodsRequest;
}>;

export type AddPaymentMethodsMutation = {
  __typename?: 'Mutation';
  addPaymentMethods: {
    __typename?: 'AddPaymentMethodsResponse';
    message?: string;
    ongoingCaseId?: string;
    ongoingCaseStatus?: string;
    status?: string;
  };
};

export type AddSupplementalFilesMutationVariables = Exact<{
  fileUris: Array<Scalars['String']> | Scalars['String'];
}>;

export type AddSupplementalFilesMutation = {
  __typename?: 'Mutation';
  addSupplementalFiles: { __typename?: 'BaseResponse'; status?: string };
};

export type SaveDraftMutationVariables = Exact<{
  draft: Scalars['String'];
  draftType?: InputMaybe<DraftType>;
}>;

export type SaveDraftMutation = {
  __typename?: 'Mutation';
  saveDraft: { __typename?: 'BaseResponse'; status?: string };
};

export type SelectReserveMutationVariables = Exact<{
  caseId: Scalars['String'];
  userSelection: UserReserveSelection;
}>;

export type SelectReserveMutation = {
  __typename?: 'Mutation';
  selectReserve: { __typename?: 'BaseResponse'; status?: string };
};

export type SubmitKybMutationVariables = Exact<{
  evaluateRequest: EvaluateRequestInput;
}>;

export type SubmitKybMutation = {
  __typename?: 'Mutation';
  submitKyb: { __typename?: 'BaseResponse'; status?: string };
};


// ─── Document exports (plain query strings, typed for type-safety) ────────────

export const GetAccountKybStatusDocument: DocumentNode<GetAccountKybStatusQuery, GetAccountKybStatusQueryVariables> = GET_ACCOUNT_KYB_STATUS;
export const GetApprovedPaymentMethodsForOngoingKybDocument: DocumentNode<GetApprovedPaymentMethodsForOngoingKybQuery, GetApprovedPaymentMethodsForOngoingKybQueryVariables> = GET_APPROVED_PAYMENT_METHODS_FOR_ONGOING_KYB;
export const GetClientLegalEntityDocument: DocumentNode<GetClientLegalEntityQuery, GetClientLegalEntityQueryVariables> = GET_CLIENT_LEGAL_ENTITY;
export const GetDraftDocument: DocumentNode<GetDraftQuery, GetDraftQueryVariables> = GET_DRAFT;
export const GetFileUploadTokenDocument: DocumentNode<GetFileUploadTokenQuery, GetFileUploadTokenQueryVariables> = GET_FILE_UPLOAD_TOKEN;
export const GetI18nContentDocument: DocumentNode<GetI18nContentQuery, GetI18nContentQueryVariables> = GET_I18N_CONTENT;
export const GetInProgressPaymentMethodsForIncrementalPaymentActivationDocument: DocumentNode<GetInProgressPaymentMethodsForIncrementalPaymentActivationQuery, GetInProgressPaymentMethodsForIncrementalPaymentActivationQueryVariables> = GET_IN_PROGRESS_PAYMENT_METHODS_FOR_INCREMENTAL_PAYMENT_ACTIVATION;
export const GetInProgressPaymentMethodsForInitialPaymentActivationDocument: DocumentNode<GetInProgressPaymentMethodsForInitialPaymentActivationQuery, GetInProgressPaymentMethodsForInitialPaymentActivationQueryVariables> = GET_IN_PROGRESS_PAYMENT_METHODS_FOR_INITIAL_PAYMENT_ACTIVATION;
export const GetInProgressPaymentMethodsForSelectReserveDocument: DocumentNode<GetInProgressPaymentMethodsForSelectReserveQuery, GetInProgressPaymentMethodsForSelectReserveQueryVariables> = GET_IN_PROGRESS_PAYMENT_METHODS_FOR_SELECT_RESERVE;
export const GetInReviewPaymentMethodsDocument: DocumentNode = GET_IN_REVIEW_PAYMENT_METHODS;
export const GetMerchantDataDocument: DocumentNode<GetMerchantDataQuery, GetMerchantDataQueryVariables> = GET_MERCHANT_DATA;
export const GetMidRateDocument: DocumentNode<GetMidRateQuery, GetMidRateQueryVariables> = GET_MID_RATE;
export const GetNewPaymentMethodRequiredInfoDocument: DocumentNode<GetNewPaymentMethodRequiredInfoQuery, GetNewPaymentMethodRequiredInfoQueryVariables> = GET_NEW_PAYMENT_METHOD_REQUIRED_INFO;
export const GetOngoingCaseDocument: DocumentNode<GetOngoingCaseQuery, GetOngoingCaseQueryVariables> = GET_ONGOING_CASE;
export const GetPaymentMethodsDocument: DocumentNode<GetPaymentMethodsQuery, GetPaymentMethodsQueryVariables> = GET_PAYMENT_METHODS;
export const GetPlatformPaymentMethodsDocument: DocumentNode<GetPlatformPaymentMethodsQuery, GetPlatformPaymentMethodsQueryVariables> = GET_PLATFORM_PAYMENT_METHODS;
export const GetPlatformPaymentsTypeDocument: DocumentNode<GetPlatformPaymentsTypeQuery, GetPlatformPaymentsTypeQueryVariables> = GET_PLATFORM_PAYMENTS_TYPE;
export const GetReserveOptionsDocument: DocumentNode<GetReserveOptionsQuery, GetReserveOptionsQueryVariables> = GET_RESERVE_OPTIONS;
export const GetReserveOptionsForOngoingKybDocument: DocumentNode<GetReserveOptionsForOngoingKybQuery, GetReserveOptionsForOngoingKybQueryVariables> = GET_RESERVE_OPTIONS_FOR_ONGOING_KYB;
export const GetScaleSettingByPlatformAccountIdDocument: DocumentNode<GetScaleSettingByPlatformAccountIdQuery, GetScaleSettingByPlatformAccountIdQueryVariables> = GET_SCALE_SETTING_BY_PLATFORM_ACCOUNT_ID;
export const GetUserPaymentMethodsStatusDocument: DocumentNode<GetUserPaymentMethodsStatusQuery, GetUserPaymentMethodsStatusQueryVariables> = GET_USER_PAYMENT_METHODS_STATUS;
export const GetUserReservePlanDocument: DocumentNode<GetUserReservePlanQuery, GetUserReservePlanQueryVariables> = GET_USER_RESERVE_PLAN;
export const GetUserSelectedPaymentMethodsDocument: DocumentNode<GetUserSelectedPaymentMethodsQuery, GetUserSelectedPaymentMethodsQueryVariables> = GET_USER_SELECTED_PAYMENT_METHODS;
export const AddPaymentMethodsDocument: DocumentNode<AddPaymentMethodsMutation, AddPaymentMethodsMutationVariables> = ADD_PAYMENT_METHODS;
export const AddSupplementalFilesDocument: DocumentNode<AddSupplementalFilesMutation, AddSupplementalFilesMutationVariables> = ADD_SUPPLEMENTAL_FILES;
export const SaveDraftDocument: DocumentNode<SaveDraftMutation, SaveDraftMutationVariables> = SAVE_DRAFT;
export const SelectReserveDocument: DocumentNode<SelectReserveMutation, SelectReserveMutationVariables> = SELECT_RESERVE;
export const SubmitKybDocument: DocumentNode<SubmitKybMutation, SubmitKybMutationVariables> = SUBMIT_KYB;
